import { settlementTexts } from 'consts/text';
import { ChildPaymentType } from '../types';

export const getChildPaymentTransactionTypeText = (transferTypes: ChildPaymentType) => {
    switch (transferTypes) {
        case ChildPaymentType.PAYMENT:
            return settlementTexts.children.addBill.charge;
        case ChildPaymentType.COST:
            return settlementTexts.children.addBill.cost;
        case ChildPaymentType.REVERSAL:
            return settlementTexts.children.addBill.cancelTransaction;
        case ChildPaymentType.ADJUSTMENT:
            return settlementTexts.children.addBill.adjustment;
        default:
            return settlementTexts.children.addBill.unknown;
    }
};
